import "core-js/modules/es.promise.js";
import React from 'react';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { DropCameraButton } from "../drop-common";
import { RippleButton } from '@isyc-react/form/modules/base';
import { useTranslation } from 'react-i18next';
import { nsformfile } from "../../../../i18n/namespaces";
import { componentsMultiFileStatus } from "../../components";
import '@isyc-react/design/main';
export const DropMultiDefaultView = props => {
  const {
    open,
    disabled,
    onFile,
    camera
  } = props;
  const {
    t
  } = useTranslation(nsformfile.common);
  return /*#__PURE__*/React.createElement("div", {
    className: "drop-file-default-view-single"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-cloud-upload-outline font-size-50 text-light-grey"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, t('drop.zone.message')), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 mb-3"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-primary",
    onClick: open,
    disabled: disabled
  }, t('drop.zone.button'))), /*#__PURE__*/React.createElement(DropCameraButton, {
    onFile: onFile,
    options: camera,
    disabled: disabled
  })));
};
export const DropMultiFileStatusHeader = props => {
  const {
    drop,
    common,
    camera,
    status
  } = props;
  const {
    open
  } = drop;
  const {
    value,
    disabled,
    onChange
  } = common;
  const {
    addFile,
    removeAll
  } = status;
  const {
    t
  } = useTranslation(nsformfile.common);
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, common.value && /*#__PURE__*/React.createElement("div", {
    className: "col d-flex align-items-center pb-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "me-1 my-0",
    htmlFor: "numOfUploadedArchives"
  }, t('doc.management.multiupload.numberOfFiles')), /*#__PURE__*/React.createElement("b", {
    className: "ms-2"
  }, common.value.accepted.length)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-auto d-flex align-items-center justify-content-end pb-3",
    style: {
      borderBottom: '1px solid #F3F3F3'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropCameraButton, {
    options: camera,
    onFile: addFile
  })), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary",
    onClick: open
  }, "Add more (camera or disk [WIP])"), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary",
    onClick: () => {
      removeAll();
    }
  }, "Remove all")));
};
export const DropMultiFileStatus = props => {
  const {
    drop,
    common,
    camera,
    components = componentsMultiFileStatus,
    status
  } = props;
  const {
    open
  } = drop;
  const {
    value,
    disabled,
    onChange
  } = common;
  const {
    addFile
  } = status;
  const {
    DefaultView = componentsMultiFileStatus.DefaultView,
    Header = componentsMultiFileStatus.Header,
    List = componentsMultiFileStatus.List
  } = components;
  if (value !== null && value !== void 0 && value.accepted && value.accepted.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, props), /*#__PURE__*/React.createElement(List, props));
  } else if (value !== null && value !== void 0 && value.rejected && value.rejected.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, props), /*#__PURE__*/React.createElement(List, props));
  } else {
    return /*#__PURE__*/React.createElement(Slug, {
      config: {
        tension: 100,
        friction: 10
      },
      from: {
        opacity: 0,
        transform: 'translate3d(0px,50px,0)'
      }
    }, /*#__PURE__*/React.createElement(DefaultView, {
      open: open,
      camera: camera,
      disabled: disabled,
      onFile: addFile
    }));
  }
};